import type { Practice } from "services/types/clinics.type";
import type { FormTemplate } from "services/types/form-templates.type";

import EnumDataSource from "../utils/enum-data-source.util";

export const PURCHASE_FORM_TEMPLATE_TYPE = 1;
export const REPAIR_FORM_TEMPLATE_TYPE = 2;
export const RETURN_FORM_TEMPLATE_TYPE = 3;
export const LOANER_FORM_TEMPLATE_TYPE = 5;
export const PATIENT_FORM_TEMPLATE_TYPE = 6;

export const BUILTIN_INTAKE_FORM_ID = -1;

export const BUILTIN_INTAKE_FORM: FormTemplate = {
  id: BUILTIN_INTAKE_FORM_ID,
  title: "Patient Intake Form",
  type: PATIENT_FORM_TEMPLATE_TYPE,
  anvil_id: "",
  data_mapping: {},
  practice: {} as Practice
};
export const APPOINTMENT_FORM_TEMPLATE_TYPE = 7;
export const ORDER_FORM_TEMPLATE_TYPE = 8;
export const CUSTOM_FORM_TEMPLATE_TYPE = 9;

const formTemplateTypes = {
  [PURCHASE_FORM_TEMPLATE_TYPE]: "Purchase Agreement",
  [RETURN_FORM_TEMPLATE_TYPE]: "Return",
  [REPAIR_FORM_TEMPLATE_TYPE]: "Repair",
  [LOANER_FORM_TEMPLATE_TYPE]: "Loaner",
  [PATIENT_FORM_TEMPLATE_TYPE]: "Patient",
  [APPOINTMENT_FORM_TEMPLATE_TYPE]: "Appointment",
  [ORDER_FORM_TEMPLATE_TYPE]: "Purchase",
  [CUSTOM_FORM_TEMPLATE_TYPE]: "Form"
};

export const FORM_TEMPLATE_TYPES = new EnumDataSource(formTemplateTypes);
